<template>
  <section id="testimonial" class="section bg-secondary">
    <div class="container">
      <!-- Heading -->
      <h2
        class="text-10 fw-600 text-center mb-5 wow fadeIn"
        style="visibility: visible"
      >
        Happy Clients
      </h2>
      <!-- Heading end-->
      <div
        id="carouselExampleDark"
        class="carousel carousel-dark slide"
        data-bs-ride="carousel"
      >
        <div class="carousel-indicators">
          <button v-for="(review,index) in sortedReviews" :key="review.id" type="button" data-bs-target="#carouselExampleDark" :data-bs-slide-to="index" :class="index == 0 ? 'active' :''" :aria-current="index == 0 ? 'true':''" :aria-label="'Slide '+ [index + 1]"></button>          
        </div>
        <div class="carousel-inner">
          <div v-for="review in sortedReviews" :key="review.id" :class="['carousel-item',sortedReviews.length == review.id ? 'active':'']" :data-bs-interval="[review.id== 1 ? '10000':'15000']">
            <div
              class="carousel-caption d-md-block py-5"
              style="position: relative; left: 0px; width: 70%; margin: auto"
            >
              <p class="text-5">
                "{{review.description}}"
              </p>
              <img
                :src="require(`@/${review.image}`)"
                class="img-fluid d-inline-block w-auto rounded-circle shadow"
              />
              <h5 class="mt-4">{{review.name}}</h5>
            </div>
          </div>
        
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import reviewjson from "@/json/customerreview.json";

export default {
  name: "Clients-review",
  data() {
    return {
      reviews:reviewjson
    };
  },
  computed: {
    sortedReviews() {
     return this.reviews.filter(() => true).sort((a,b)=> b['id']- a['id'])
    }
  }
};
</script>

<style scoped>
.carousel .item > img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  height: 100%;
}
.rounded-circle {
  border: 4px solid white;
}
</style>
